import React from "react";
import PropTypes from "prop-types";
import { makeStyles } from "@material-ui/styles";
import CardActions from "@material-ui/core/CardActions";
import {Button} from "components/Shared";

//When displaying in a dialog context the component is outside the reach of our style sheets so I needed to do this
const useStyles = makeStyles(({spacing}) => ({
  Root: {
    "& > :not(:last-child)": {
    marginRight: spacing(1),
    }
  },
}));

const ActionButtons = ({buttonPropSets}) => {
  const classes = useStyles();
  return (
    <CardActions
      className={classes.Root}
      disableSpacing
    >
      {buttonPropSets.map(({children, ...otherButtonProps}, index) =>
        <Button
          key={index}
          {...otherButtonProps}
        >
          {children}
        </Button>
      )}
    </CardActions>
  );
};

ActionButtons.propTypes = {
  //Array of sets of Buttons Props
  //Check out https://material-ui.com/api/button/ for more info on what these are
  buttonPropSets: PropTypes.array,
};

export default ActionButtons;